/*@flow*/
import type { Node } from 'react';
import React, { useEffect, useState, createRef, useContext } from 'react';
import useAutocomplete from 'lib/useAutocomplete';
import delay from 'lib/delay';
import Blank from 'lib/Blank';
import transformPlace from './transformPlace';
import commands from './commands';
import context from './context';

export default (): null | Node => {
  const ctx = useContext(context);
  const { theGeom, theGeomName } = ctx.state;
  const ref = createRef();
  const [place, setPlace] = useState({});
  const { googPlace, apiRef } = useAutocomplete(ref, [theGeom]);

  useEffect(() => {
    if (!place) return;
    if (Blank.is(place.center)) return;
    commands(ctx).setLocation(place.center);
  }, [place]);

  useEffect(() => {
    if (!googPlace) return;
    setPlace(transformPlace(googPlace));
  }, [googPlace]);

  useEffect(() => {
    if (!apiRef.current) return;
    if (apiRef.current.isStarted()) return;
    if (!ref.current) return;
    if (!theGeom) return;
    delay(100).then(() => {
      apiRef.current && !apiRef.current.isStarted() && apiRef.current.start();
    });
  }, [ref.current, theGeom]);

  if (!theGeom) return null;

  return (
    <React.Fragment>
      <div className="location-field border-bottom">
        <div className="d-flex">
          <div
            style={{ width: '3.5rem' }}
            className="text-flex-center text-black-50"
          >
            <i
              className="fa fa-location-arrow"
              style={{ fontSize: '0.5rem' }}
            />
          </div>
          <input
            placeholder="Search for location by address"
            defaultValue={place.fullAddress || ''}
            ref={ref}
            autoComplete="off"
            className="form-control form-control-lg search-for-location border-0"
            style={{ fontSize: '1.4rem' }}
          />
        </div>
        <input type="hidden" defaultValue={theGeom} name={theGeomName} />
      </div>
    </React.Fragment>
  );
};
